import React from 'react'
import { TheWestSomethingWentWrong } from 'component-library/errors/SomethingWentWrong/TheWestSomethingWentWrong/TheWestSomethingWentWrong'
import { RouteStatus } from 'common/routing/RouteStatus'
import { createRegisterableComponent } from 'common/routing/page-definition'

export const TheWestSomethingWentWrongRegistration = createRegisterableComponent(
    'west-500-page',
    () => (
        <RouteStatus statusCode={500}>
            <TheWestSomethingWentWrong />
        </RouteStatus>
    )
)
